import InfoLayout from "./InfoLayout";

function Compatibility() {
  return (
    <InfoLayout title="Compatibility">
      <p>
        <strong>Tabata Timer</strong> is primarily designed for desktop environments – ideal for
        computers, monitors, laptops, and TVs. This ensures a full-featured user experience with a
        clear and intuitive interface.
      </p>

      <p>
        The app can also be launched on tablets or mobile phones. On smaller screens, the user
        experience may be limited by display size, but the app remains fully functional. Simply enter
        the web address in your browser – <strong>no installation or registration</strong> required.
      </p>

      <h2 className="text-xl font-semibold mt-4">Resolution and Display</h2>
      <p>
        The app is optimized for standard Full HD TV resolution and monitors with 1920×1200. With
        other resolutions, slight scrolling may be required to view all content completely.
      </p>

      <h2 className="text-xl font-semibold mt-4">Recommended Browsers</h2>
      <p>
        For the best experience, we recommend using Google Chrome or Microsoft Edge, which the app
        has been tested and optimized for. However, it should also work smoothly in other modern
        browsers.
      </p>

      <h2 className="text-xl font-semibold mt-4">Device Performance</h2>
      <p>
        <strong>Tabata Timer</strong> is lightweight and can run on all standard computers, laptops,
        tablets, and mobile phones.
      </p>

      <h2 className="text-xl font-semibold mt-4">Running on Mobile Systems</h2>
      <p>
        The app is compatible with both Android and iOS. On some mobile devices, the phone may switch
        to sleep mode during a workout. Tabata Timer is designed to prevent this, but if it occurs,
        a simple solution is to extend the screen timeout settings on your phone.
      </p>
    </InfoLayout>

  );
}

export default Compatibility;
